import React, { Component } from 'react';
import moment from 'moment';
import { Example, Properties, SourceCode } from 'examples';
import Calendar from '../Calendar/Calendar';
import DateInput from './DateInput';

export default class DateInputExample extends Component {

  state = {
    selected: moment(),
    showCalendar: false,
  };

  onChange = date => this.setState({ selected: date ? date.clone() : null });

  onPropChange = e => this.setState(e.target.value);

  closeCalendar = () => this.setState({ showCalendar: false });

  render() {
    const properties = { ...DateInput.propTypes, ...Calendar.propTypes };
    const defaultProperties = { ...DateInput.defaultProps, ...Calendar.defaultProps };

    return (
      <Example {...this.props}>
        <Properties defaultProps={defaultProperties} onChange={this.onPropChange} propTypes={properties} propValues={this.state} exclude={['integratedInput']}/>
        <DateInput showCalendar={this.state.showCalendar} {...this.state}
          onCloseCalendar={this.closeCalendar} onCloseMenu={this.closeCalendar} onChange={this.onChange} />
        <SourceCode language="javascript" title="The onChange callback">
          {
            '/* For the DateInput view to be updated the onChange and selected prop must be implemented. Example: */\n' +
            '\n' +
            'constructor() {\n' +
            '  this.state = { selected: moment() }\n' +
            '}\n' +
            '\n' +
            'onChange(date) {\n' +
            '  // the date parameter is a moment object\n' +
            '  this.setState({ selected: date })\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<Calendar onChange={this.onChange.bind(this)} selected={this.state.selected}/>);\n' +
            '}'
          }
        </SourceCode>
        <SourceCode querySelector=".core-dateinput"/>
        <SourceCode language="javascript" title="Locale and utcOffset props">
          {
            '/* The DateInput is default set to utc.\n' +
            '* For a different timezone use the utcOffset prop.\n' +
            '* For language and start of week set the locale prop. */\n' +
            '\n' +
            'render() {\n' +
            '  const localUtcOffset = moment().utcOffset(); //Use the computer\'s local timezone \n' +
            '  const local = moment().locale(); \n' +
            '  return (<DateInput utcOffset={localeUtcOffset} locale={local}/>);\n' +
            '}'
          }
        </SourceCode>
        <SourceCode language="javascript" title="Filtered and highlighted props">
          {
            '/* See http://momentjs.com/docs/#/query/ for more Moment JS queries methods */\n' +
            '\n' +
            '// Highlighted moments example\n' +
            'highlight(date) {\n' +
            ' return date.isBetween(moment(), moment().add(5, \'days\'));\n' +
            '}\n' +
            '\n' +
            '// Filtered moments example\n' +
            'isWeekday(date) {\n' +
            ' return date.day() !== 0 && date.day() !== 6;\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<DateInput onSelect={this.onSelect.bind(this)} selected={this.state.selected} filtered={this.isWeekday} highlighted={this.highlight}/>);\n' +
            '}'
          }
        </SourceCode>
      </Example>
    );
  }

}
